<template>
  <div class="app-container">
    <div class="formBox margbot" ref="inpBox">
      <el-form :inline="true" :model="formData" ref="formData" size="mini" label-width="100px">
        <div class="formItemBox">
        <el-form-item label="移库时间:">
          <div style="display: flex;">
            <el-date-picker v-model="formData.transferDateStart" size="mini" type="datetime" placeholder="选择移库日期"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            -
            <el-date-picker v-model="formData.transferDateEnd" size="mini" placeholder="选择移库日期" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="一级货主:">
          <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:">
          <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货权方:">
          <el-select v-model="formData.ownerCustomerTaxId" size="mini" placeholder="请选择货权方" filterable clearable>
            <el-option v-for="(item, index) in HQData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-select v-model="formData.productType" size="mini" placeholder="请选择货物类型" filterable clearable
            @change="productTypeChange">
            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
              :value="item.productType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地:">
          <el-select v-model="formData.steelMillName" size="mini" placeholder="请选择产地" filterable clearable
            @change="steelMillNameChange">
            <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格:">
          <el-select v-model="formData.specification" size="mini" placeholder="请选择规格" filterable clearable
            @change="specificationChange">
            <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材质:">
          <el-select v-model="formData.model" size="mini" placeholder="请选择材质" filterable clearable @change='modelChange'>
            <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="移库前仓位:">
          <el-select v-model="formData.warehouseId" size="mini" @change="changeCangWei1(formData.warehouseId)"
            placeholder="请选择移库前仓位" filterable clearable>
            <el-option v-for="item in ckData" :key="item.warehouseId" :label="item.warehouseName"
              :value="item.warehouseId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="移库前区位:">
          <el-select v-model="formData.locationId" size="mini" placeholder="请选择移库前区位" filterable clearable>
            <el-option v-for="item in QUData1" :key="item.locationId" :label="item.locationName" :value="item.locationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="移库后仓位:">
          <el-select v-model="formData.transferWarehouseId" size="mini" @change="changeCangWei2(formData.transferWarehouseId)"
            placeholder="请选择移库后仓位" filterable clearable>
            <el-option v-for="item in ckData" :key="item.warehouseId" :label="item.warehouseName"
              :value="item.warehouseId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="移库后区位:">
          <el-select v-model="formData.transferLocationId" size="mini" placeholder="请选择移库后区位" filterable clearable>
            <el-option v-for="item in QUData2" :key="item.locationId" :label="item.locationName" :value="item.locationId">
            </el-option>
          </el-select>
        </el-form-item>
        </div>
        <el-form-item style="margin-left: 5px;">
          <el-button type="primary" size="mini" @click="chaxun" btnCode="003P01TB001" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="003P01TB002" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" btnCode="003P01TB003" v-if="btnFlg[2]">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div :style="{ height: H }">
      <el-table height="100%" size="mini" ref="tabref" :data="tableData" style="width: 100%" :header-cell-style="{
        background: '#F5F5F5',
        color: 'black',
      }" highlight-current-row border center bordersize="mini" class="tableComent">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="操作时间" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ownerCustomerName" label="货权方" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
          width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
          width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"
          width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="移库前仓位" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="locationName" label="移库前区位" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferWarehouseName" label="移库后仓位" align="center"
          width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferLocationName" label="移库后区位" align="center"
          width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferNumber" label="移库件数" align="center"
          width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" property="transferStockWeight" label="移库理重（吨）" align="center"
          width="150">
          <template v-slot="scope">
            <span>{{ Number(scope.row.transferStockWeight).toFixed(3) }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferPoundWeight" label="移库磅重（吨）" width="130"
          align="center">
          <template v-slot="scope">
            <span>{{ Number(scope.row.transferPoundWeight).toFixed(3) }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="操作人" width="150"
          align="center"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pags">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getRelationCustomer, getTransferRecordListZY, getVirtualBalingList } from '@/api/wms-stock'
import { zidianKuwei, zidianQuwei } from '@/api/wms-access'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      formData: {
        transferDateStart: '',
        transferDateEnd: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        ownerCustomerTaxId: '',
        specification: '',
        model: '',
        warehouseId: '',
        transferWarehouseId: '',
        locationId: '',
        transferLocationId: '',
        steelMillName: '',
        productType: ''
      },
      btnFlg: [],
      btnIdArr: [
        '003P01TB001',
        '003P01TB002',
        '003P01TB003'
      ],
      tableData: [],
      H: '500px',
      pageInfo: {
        pageSize: 20,
        pageNo: 1
      },
      RKData: [],
      HQData: [], // 货权方
      productTypeData: [],
      total: 0,
      specificationData: [],
      modelData: [],
      ckData: [],
      QUData1: [],
      QUData2: [],
      steelMillNameData: [],
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/moveRecord')
    this.getRelationCustomerS()
    this.zidianKuweiS()
    this.getTransferRecordListZYs()
    this.getVirtualBalingList()
  },
  mounted () {
    let h = this.$refs.inpBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.H = pH - h - 168 + 'px'
  },
  methods: {
    chaxun () {
      this.getTransferRecordListZYs()
    },
    chongzhi () {
      this.formData.transferDateStart = ''
      this.formData.transferDateEnd = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.warehouseId = ''
      this.formData.locationId = ''
      this.formData.transferWarehouseId = ''
      this.formData.transferLocationId = ''
      this.formData.steelMillName = ''
      this.formData.productType = ''
      this.formData.ownerCustomerTaxId = ''
      this.goodsName = ''
      this.placeOfOrigin = ''
      this.specificationVal = ''
      this.modelVal = ''
      this.getTransferRecordListZYs()
      this.getVirtualBalingList()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockThread/exportTransferRecordList',
        { ...this.formData, ...this.pageInfo },
        '移库单据表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getTransferRecordListZYs()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getTransferRecordListZYs()
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      this.goodsName = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      this.placeOfOrigin = val

      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      this.specificationVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      this.modelVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 主表
    getTransferRecordListZYs () {
      getTransferRecordListZY(
        {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          transferDateStart: this.formData.transferDateStart,
          transferDateEnd: this.formData.transferDateEnd,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          specification: this.formData.specification,
          model: this.formData.model,
          warehouseId: this.formData.warehouseId,
          locationId: this.formData.locationId,
          transferWarehouseId: this.formData.transferWarehouseId,
          transferLocationId: this.formData.transferLocationId,
          steelMillName: this.formData.steelMillName,
          productType: this.formData.productType,
          ownerCustomerTaxId: this.formData.ownerCustomerTaxId
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.RKData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({ 'custerName': '无货权方', 'taxpayerNumber': '-1' })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    changeCangWei1 (val) {
      this.$set(this.formData, 'locationId', '')
      zidianQuwei({
        warehouseId: val
      })
        .then((res) => {
          this.QUData1 = res
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    changeCangWei2 (val) {
      this.$set(this.formData, 'transferLocationId', '')

      zidianQuwei({
        warehouseId: val
      })
        .then((res) => {
          this.QUData2 = res
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.ckData = res
          // this.zidianQuweiS();
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }

  }
}
</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    // margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
